import * as angular from 'angular';

export class BrowserController {}

export const BrowserComponent: angular.IComponentOptions = {
  controller: BrowserController,
  controllerAs: 'ctrl',
  bindings: {},
  transclude: {
    header: 'browserHeader',
    body: 'browserBody',
    footer: 'browserFooter',
  },
  template: `
    <div ng-transclude="header"></div>
    <div ng-transclude="body"></div>
    <div ng-transclude="footer"></div>
  `,
};
